import { render, staticRenderFns } from "./dietitian.vue?vue&type=template&id=7d55513e&scoped=true&"
import script from "./dietitian.vue?vue&type=script&lang=js&"
export * from "./dietitian.vue?vue&type=script&lang=js&"
import style0 from "./dietitian.vue?vue&type=style&index=0&id=7d55513e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d55513e",
  null
  
)

component.options.__file = "dietitian.vue"
export default component.exports